import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { MusicPlayer } from "@/components/MusicPlayer";
import { Toaster } from "@/components/ui/sonner";
import { InstallPWA } from "@/components/InstallPWA";
import Home from "@/pages/Home";
import Schedule from "@/pages/Schedule";
import Standings from "@/pages/Standings";
import Playoffs from "@/pages/Playoffs";
import Shootout from "@/pages/Shootout";
import PastSeasons from "@/pages/PastSeasons";
import Teams from "@/pages/Teams";
import Stats from "@/pages/Stats";
import Highlights from "@/pages/Highlights";
import Rules from "@/pages/Rules";
import Register from "@/pages/Register";
import Waiver from "@/pages/Waiver";
import PlayerOfWeek from "@/pages/PlayerOfWeek";
import GameRecap from "@/pages/GameRecap";
import PayOptions from "@/pages/PayOptions";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ScorekeeperGame from "@/pages/ScorekeeperGame";

function PublicLayout() {
  return (
    <>
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <MusicPlayer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
          <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/teams" element={<Teams />} />
              <Route path="/standings" element={<Standings />} />
              <Route path="/playoffs" element={<Playoffs />} />
              <Route path="/shootout" element={<Shootout />} />
              <Route path="/seasons" element={<PastSeasons />} />
              <Route path="/stats" element={<Stats />} />
              <Route path="/player-of-the-week" element={<PlayerOfWeek />} />
              <Route path="/recap/:gameId" element={<GameRecap />} />
              <Route path="/highlights" element={<Highlights />} />
              <Route path="/rules" element={<Rules />} />
              <Route path="/register" element={<Register />} />
              <Route path="/waiver" element={<Waiver />} />
              <Route path="/pay" element={<PayOptions />} />
            </Route>
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/score/:gameId" element={<ScorekeeperGame />} />
          </Routes>
          <Toaster position="bottom-right" theme="dark" richColors />
          <InstallPWA />
          </BrowserRouter>
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
